import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import "./index.css";
import VITE_ENV from "./config/constants/vite-env";
import queryClient from "./config/settings/query-client-settings";
import router from "./config/settings/router-client-settings";
import { AntdConfigProvider } from "./config/settings/antd-config-provider";
import "leaflet/dist/leaflet.css";
import { ThemeProvider } from "@base/hooks/useTheme/useTheme";
import TanstackDevtoolsProvider from "@base/components/devtools/tanstack-devtools-provider";
import dayjs from "dayjs";
import "dayjs/locale/es";
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: VITE_ENV.SENTRY_DSN,
  environment: VITE_ENV.IS_DEV ? "development" : "production",
  release: VITE_ENV.APP_VERSION,
  tracesSampleRate: VITE_ENV.IS_DEV ? 1.0 : 0.2,
  enabled: !!VITE_ENV.SENTRY_DSN,
});

// Configurar dayjs globalmente
dayjs.locale("es");
// Render the app
const rootElement = document.getElementById("root")!;
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <StrictMode>
      <Sentry.ErrorBoundary
        fallback={({ error, resetError }) => (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              height: "100vh",
              fontFamily: "sans-serif",
            }}
          >
            <h1>Ocurrió un error inesperado</h1>
            <pre style={{ color: "#7f1549" }}>
              {(error as Error)?.message || "Error desconocido"}
            </pre>
            <button onClick={resetError}>Reintentar</button>
          </div>
        )}
      >
        <QueryClientProvider client={queryClient}>
          <ThemeProvider defaultTheme="light" storageKey="vite-theme">
            <AntdConfigProvider>
              <RouterProvider router={router} />
              <TanstackDevtoolsProvider
                show={VITE_ENV.IS_DEV && VITE_ENV.SHOW_DEVTOOLS}
                router={router}
              />
            </AntdConfigProvider>
          </ThemeProvider>
        </QueryClientProvider>
      </Sentry.ErrorBoundary>
    </StrictMode>,
  );
}
